import React, {Component} from 'react'
import cn from 'classnames'

class Toggle extends Component {
    render(){
        let cx = cn('toggle', this.props.className)
        return (
            <div className={cx}>
              <div className={this.props.horizontalToggle ? 'toggle-label-horizontal' :'toggle-label'} />
              <div className={this.props.on ? (this.props.horizontalToggle ? 'toggle-left' :'toggle-on') : (this.props.horizontalToggle ? 'toggle-right':'toggle-off')} 
                   onClick={()=>this.props.toggle(this.props.type)} />
            </div>
        )
    }
}

export default class TimelineBasicToggles extends Component {
    render(){
        let { basic, completion, toggleUpdate} = this.props
        return (
          <div className="timeline-toggles">
            <div
              className={`basic-label ${basic ? "enable" : "disable"}`}
              onClick={() => toggleUpdate("basic")}
            />
            <Toggle
              toggle={toggleUpdate}
              type="basic"
              on={basic}
              className="basic"
              horizontalToggle={true}
            />
            <div
              className={`advanced-label ${basic ? "disable" : "enable"}`}
              onClick={() => toggleUpdate("basic")}
            />
          </div>
        );
    }
}
